import { ElementRef } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

export interface FileUploadState {
  file: FormData;
  nomeArquivo: string;
  checkArquivo: boolean;
}

export function capturarArquivo(
  event: any,
  state: FileUploadState,
  inputFile: ElementRef,
  toastr: ToastrService,
  extensoesValidas: string[],
): void {
  state.file = new FormData();
  state.nomeArquivo = 'Selecionar arquivo';

  if (!event.target.files?.[0]) {
    state.checkArquivo = false;
    inputFile.nativeElement.value = '';
    return;
  }

  const arquivo = event.target.files[0];
  state.file.append('file', arquivo);
  state.nomeArquivo = arquivo.name;

  const partes = arquivo.name.split('.');
  const extensao = '.' + partes[partes.length - 1].toLowerCase();

  if (extensoesValidas.includes(extensao)) {
    state.checkArquivo = true;
    toastr.success(`${state.nomeArquivo} carregado com sucesso`, '', { timeOut: 2000 });
  } else {
    state.checkArquivo = false;
    state.nomeArquivo = '';
    toastr.error(`${arquivo.name} possui formato inválido!`, '', { timeOut: 2000 });
  }
}

export function cancelarCapturaArquivo(
  state: FileUploadState,
  inputFile: ElementRef,
  toastr: ToastrService,
): void {
  state.checkArquivo = false;
  if (state.nomeArquivo && state.nomeArquivo !== 'Selecionar arquivo') {
    toastr.error('Arquivo excluído', '', { timeOut: 2000 });
  }
  state.nomeArquivo = 'Selecionar arquivo';
  inputFile.nativeElement.value = '';
}
